module.exports = __webpack_public_path__ + "static/media/importICloud3.04842e65.png";